import customFetch from '../../../utils/customFetch';

export const getAssessmentInfo = id => {
  return customFetch('/MedicalService/PostAssessmentInfo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
};

export const getStaffGetAll = (
  IsSelectionList = true,
  Showing = 'active',
  curPage = 1,
  keyword = '',
  numItemPerPage = 30,
  companyId = 0,
) => {
  return customFetch('/Staff/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: IsSelectionList,
      Showing: Showing,
      curPage: curPage,
      keyword: keyword,
      numItemPerPage: numItemPerPage,
      companyId: companyId,
    }),
  });
};

export const getIMSApprovalCode = () => {
  return customFetch('/MedicalService/GetIMSApprovalCode', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getWIROPrincipleLawyer = () => {
  return customFetch('/MedicalService/GetWIROPrincipleLawyer', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getRooms = (clinicId = 0) => {
  return customFetch('/Clinic/GetRooms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clinicId }),
  });
};

export const getClinicList = (
  IsSelectionList = true,
  curPage = 1,
  doctorId = 2926,
  numItemPerPage = 30,
  type = 'mag',
) => {
  return customFetch('/Clinic/GetClinicList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: IsSelectionList,
      curPage: curPage,
      doctorId: doctorId,
      numItemPerPage: numItemPerPage,
      type: type,
    }),
  });
};

export const getConversationList = (AssessmentId = 0) => {
  return customFetch('/MedicalService/ConversationLog_LoadList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ AssessmentId }),
  });
};

export const getAllWithoutNCI = (
  IsSelectionList = true,
  RecruitedOrContractedOnly = true,
  Showing = 'active',
  curPage = 1,
  keyword = '',
  numItemPerPage = 30,
) => {
  return customFetch('/MedicalDoctor/GetAllWithoutNCI', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: IsSelectionList,
      RecruitedOrContractedOnly: RecruitedOrContractedOnly,
      Showing: Showing,
      curPage: curPage,
      keyword: keyword,
      numItemPerPage: numItemPerPage,
    }),
  });
};

export const getActiveClaimTypeList = () => {
  return customFetch('/Default/GetActiveClaimTypeList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getPatientList = (
  IsSelectionList = true,
  Showing = 'active',
  curPage = 1,
  keyword = '',
  numItemPerPage = 30,
) => {
  return customFetch('/PatientInfo/GetPatientList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: IsSelectionList,
      Showing: Showing,
      curPage: curPage,
      keyword: keyword,
      numItemPerPage: numItemPerPage,
    }),
  });
};

export const getCompanyList = (
  IsSelectionList = true,
  Showing = 'active',
  curPage = 1,
  keyword = '',
  numItemPerPage = 30,
) => {
  return customFetch('/Company/GetAll', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      IsSelectionList: IsSelectionList,
      Showing: Showing,
      curPage: curPage,
      keyword: keyword,
      numItemPerPage: numItemPerPage,
    }),
  });
};

export const getStaffList = () => {
  return customFetch('/Default/GetStaffs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getTypists = () => {
  return customFetch('/Default/GetTypists', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getLanguageList = () => {
  return customFetch('/Default/Language_GetList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getClinicInterpretationService = () => {
  return customFetch('/MedicalService/GetClinicInterpretationService', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
};

export const getLookupConfigByTypes = (types = ['spe']) => {
  return customFetch('/Default/GetLookupConfigByTypes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ types: types }),
  });
};

export const getSpecificLookupConfigOrderNoByType = (types = 'PapToDoc') => {
  return customFetch('/Default/GetSpecificLookupConfigOrderNoByType', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ types: types }),
  });
};

export const getAllByStatus = (
  NumItemPerPage = 500,
  Showing = 'active',
) => {
  return customFetch('/MAGService/GetAllByStatus', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ NumItemPerPage: NumItemPerPage, Showing: Showing }),
  });
};

export const getAssessmentStatus = (id = 0) => {
  return customFetch(`/api/AssessmentStatus/${id}`, {
    method: 'GET',
  });
};

export const getActionRequired = (id = 0) => {
  return customFetch('/MedicalService/ActionRequired_LoadList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
};

export const getListInvoiceID = (objectId = 0) => {
  return customFetch('/MedicalDoctor/GetListInvoiceID', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ objectId: objectId, type: 'Assessment' }),
  });
};
